import React from "react";
import { ResourceDWR } from "../../../dto/ResourceDWR";
import { Button, ButtonProps } from "@mui/material";
import { useLanguage } from "../../Language";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { ResourceView } from "../../../dto/ResourceView";

interface ViewSiteButtonProps extends ButtonProps {
  site: ResourceDWR | ResourceView;
}

export const ViewSiteButton = ({ site, ...props }: ViewSiteButtonProps) => {
  const { translate } = useLanguage();
  return (
    <Button
      component="a"
      startIcon={<OpenInNewIcon />}
      {...props}
      variant="contained"
      href={site.link}
      target="_blank"
    >
      {translate("viewSite")}
    </Button>
  );
};
